/* eslint-disable import/no-anonymous-default-export */
import http from '../../helpers/http'
import qs from 'qs'

export default {
    getMonitoringTransaksi: (token, params) => ({
        type: 'GET_MONITORING_TRANSAKSI',
        payload: http(token).get(`/monitoring/transaksi?${qs.stringify(params)}`)
    })
}
